import React from "react";
import "./Successfull_Modal.css";
import { Button, Modal } from "react-bootstrap";
import Successfull_Lottie from "../../Animation/Successfull_Lottie/Successfull_Lottie";

function UpdateSuccess(props) {
  const { message } = props; // Extracting 'message' prop
  return (
    <>
      <div className="Successfull_Modal_sec">
        <Modal
          className="Successfull_Modal"
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="lottie-holder">
              {" "}
              <Successfull_Lottie />
            </div>

            <p>Data Updated Successfully</p> {/* Displaying the 'message' prop */}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default UpdateSuccess;
